<template>
  <form
    class="form-work-day"
    v-on:reset.prevent="onCancel"
    v-on:submit.prevent="onSubmit"
  >
    <time
      class="form-work-day__date"
      v-bind:datetime="datetime"
    >{{ dateTitle }}</time>
    <p class="form-work-day__doctor">
      <span class="form-work-day__name">{{ name }}</span>
      <input-checkbox
        title="Выходной"
        v-bind:disabled="!hasEditSchedule"
        v-model="isOffDay"
      />
    </p>
    <span class="form-work-day__label">Часы работы</span>
    <div
      class="form-work-day__group"
      v-for="(workTime, index) in workTimes"
      v-bind:key="index"
    >
      <div class="form-work-day__time-row">
        <time-interval-picker
          class="form-work-day__row"
          v-bind:disabled="disableEditWorkTimes"
          v-bind:initial-from="workTime.from"
          v-bind:initial-to="workTime.to"
          v-bind:time-set="suggestedHours"
          v-on:input-from="onInputWorkTimes(
            index,
            $event,
            workTime.to,
          )"
          v-on:input-to="onInputWorkTimes(
            index,
            workTime.from,
            $event,
          )"
        />
        <button
          v-if="index === 0"
          class="form-work-day__button-icon-add"
          title="Добавить"
          type="button"
          v-on:click="onAddWorkTimes" />
        <button
          v-else
          class="form-work-day__button-icon-remove"
          title="Удалить"
          type="button"
          v-on:click="onRemoveWorkTimes(index)" />
      </div>
    </div>
    <div class="form-work-day__buttons" v-if="hasEditSchedule">
      <button
        class="form-work-day__cancel"
        type="button"
        v-on:click="onCancel">Отмена</button>
      <button
        class="form-work-day__submit"
        type="submit">ОК</button>
    </div>
  </form>
</template>
<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import TimeIntervalPicker from '@/components/TimeIntervalPicker.vue';

/**
 * @description Название события отмены.
 * @type {string}
 */
const NAME_EVENT_CANCEL = 'cancel';

/**
 * @description Название события отправки формы.
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

/**
 * @description Компонент формы рабочего дня сотрудника.
 * @type {Vue}
 */
export default {
  components: {
    InputCheckbox,
    TimeIntervalPicker,
  },
  computed: {
    /**
     * @description Деактивировать редактирование часов работы.
     * @returns {boolean}
     */
    disableEditWorkTimes() {
      return this.isOffDay || !this.hasEditSchedule;
    },
  },
  data() {
    return {
      /**
       * @description Выходной.
       * @type {boolean}
       */
      isOffDay: false,
      /**
       * @description Часы работы.
       * @type {{from:string,to:string}[]}
       */
      workTimes: [...this.initialPeriods],
    };
  },
  inject: ['maxWorkIntervalsInDay'],
  methods: {
    /**
     * @description Обработать добавление часов работы.
     * @returns {void}
     */
    onAddWorkTimes() {
      this.workTimes.push({ from: '00:00', to: '00:00' });
    },
    /**
     * @description Обработать отмену.
     * @returns {void}
     */
    onCancel() {
      this.$emit(NAME_EVENT_CANCEL);
    },
    /**
     * @description Обработать ввод рабочих часов.
     * @param {number} index
     * @param {string} from
     * @param {string} to
     * @returns {void}
     */
    onInputWorkTimes(index, from, to) {
      this.$set(this.workTimes, index, { from, to });
    },
    /**
     * @description Удалить рабочие часы.
     * @param {number} index
     * @returns {void}
     */
    onRemoveWorkTimes(index) {
      this.$delete(this.workTimes, index);
    },
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmit() {
      const day = {
        workTimes: [...this.workTimes],
        date: this.datetime,
        isOff: this.isOffDay,
      };
      this.$emit(NAME_EVENT_SUBMIT, day);
    },
  },
  name: 'FormEmployeeWorkDay',
  props: {
    /**
     * @description Заголовок даты.
     */
    dateTitle: { default: '', type: String },
    /**
     * @description Дата в формате ISO.
     */
    datetime: { default: '', type: String },
    /**
     * @description Может редактировать график работы.
     */
    hasEditSchedule: { required: true, type: Boolean },
    /**
     * @description Рабочие периоды.
     */
    initialPeriods: { default: () => [], type: Array },
    /**
     * @description Имя сотрудника.
     */
    name: { default: '', type: String },
    /**
     * @description Предложенные часы работы.
     */
    suggestedHours: { default: () => [], type: Array },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
$button-font-size: 14px;
$button-height: 37px;
$button-width: 100%;
.form-work-day {
  padding: 15px 20px 27px;
  width: 500px;
  max-width: 99%;
  &__group {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0 0 10px 0;
  }
  &__date {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #707683;
  }
  &__doctor {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    margin: 5px 0 10px !important;
    label {
      display: flex;
    }
  }
  &__name {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #192A3E;
  }
  &__time-row {
    display: grid;
    grid-template-columns: 1fr 1fr 22px;
    align-items: center;
    grid-gap: 10px;
  }
  &__row {
    display: grid;
    grid-template-columns: 1fr 10px 1fr;
    grid-gap: 10px;
    align-items: center;
  }
  &__input {
    border: 1px solid #C2CFE0;
    box-sizing: border-box;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    padding: 10px;
    color: #707683;
    font-size: 16px;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 1px solid #0489e0 !important;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__button {
    &-add {
      text-align: left;
      color: #0489e0;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
    }
    &-remove {
      text-align: left;
      color: var(--warning-color);
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
    }
    &-icon-add {
      @include buttons.btn-plus-color-add;
    }
    &-icon-remove {
      @include buttons.btn-cross-color-remove;
    }
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 30px 0 0 0;
  }
  &__cancel {
    @include buttons.btn-transparent($button-width, $button-height, $button-font-size);
  }
  &__submit {
    @include buttons.btn-blue($button-width, $button-height, $button-font-size);
  }
  &__label {
    color: #707683;
    font-size: 12px;
  }
}

@media screen and (max-width: 480px) {
 .form-work-day {
  &__time-row {
    grid-template-columns: 1fr 22px;
  }
  &__row {
    grid-column: 1 / -1;
  }
 }
}
</style>
